import React from 'react';

const Footer: React.FC = () => {
  return (
    <div className='bg-rank-bgTertiary bottom-0 mt-10 w-full'>
      <p className='py-5 text-center text-sm text-rank-tertiary'>Copyright © 2023 tomotaqu All rights reserved.</p>
    </div>
  );
};
export default Footer;